import React from 'react'

const Navbar = () => {
  return (
    <div className='navbar'>
        <div className='logo'>
            Scaler - Interview Scheduler
        </div>
        <div className='nav-btns'>
            {/* <button>Interview List</button>
            <button>Create</button> */}
        </div>
    </div>
  )
}

export default Navbar;